import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { AuthService } from '../../auth/auth.service';
import { Observable } from 'rxjs';
import { TagRequest, TagResponse } from '@builtbybros/al-model';
import { environment } from '../../../environments/environment';

@Injectable()
export class TagService {

  tagUrl: string = '/Tag';

  constructor(private http: Http,
              private authService: AuthService) { }


  createTag( tagRequest: TagRequest.Create ): Observable< TagResponse.Tag > {

    const options = this.authService.addAuthToken();

    return this.http.post(environment.alApiUrl + this.tagUrl, tagRequest, options)
      .map((res) => {
        const json = res.json();

        const tagResponse = new TagResponse.Tag();
        return tagResponse.parse(json);
      });
  }

  updateTag( id: number, tagRequest: TagRequest.Update ): Observable< TagResponse.Tag > {

    const options = this.authService.addAuthToken();

    return this.http.patch(environment.alApiUrl + this.tagUrl + '/' + id, tagRequest, options)
      .map((res) => {
        const json = res.json();
        const tagResponse = new TagResponse.Tag();
        return tagResponse.parse(json);
      });
  }

  getTag(id: number): Observable<TagResponse.Tag> {
    const options = this.authService.addAuthToken();
    return this.http
      .get(environment.alApiUrl + this.tagUrl + '/' + id, options)
      .map((res: Response) => {
        const json = res.json();
        return json;
      });

  }
  getAllTags(pagination = 100, offset = 0): Observable<TagResponse.All> {
    return this.http
      .get(`${environment.alApiUrl}${this.tagUrl}/All?pagination=${pagination.toString()}&offset=${offset.toString()}`)
      .map((res: Response) => {
        const json = res.json();
        return json;
      });
  }

  // TODO: Catch error.

  deleteTag(id: number): Observable<number> {
    const options = this.authService.addAuthToken();
    return this.http
      .delete(`${environment.alApiUrl}${this.tagUrl}/${id}`, options)
      .map((res: Response) => {
        const json = res.json();
        return json;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/tags/shared/tag.service.ts